module.exports = __webpack_public_path__ + "static/img/Business.9d65a0f7.jpg";